import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
});

export const submitForm = (payload) => api.post("/submissions", payload).then((r) => r.data);

export const fetchFAQs = (category) => api.get("/faqs", { params: category ? { category } : {} }).then((r) => r.data);
export const fetchBlog = () => api.get("/blog").then((r) => r.data);
export const fetchBlogPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);

// Admin (X-Admin-Password header)
const ADMIN_KEY = "wasz_admin_pw";
export const setAdminPassword = (pw) => sessionStorage.setItem(ADMIN_KEY, pw);
export const clearAdminPassword = () => sessionStorage.removeItem(ADMIN_KEY);
export const getAdminPassword = () => sessionStorage.getItem(ADMIN_KEY) || "";
const adminHeaders = () => ({ "X-Admin-Password": getAdminPassword() });

export const verifyAdmin = (pw) =>
  api.post("/admin/verify", null, { headers: { "X-Admin-Password": pw } }).then((r) => r.data);
export const fetchAdminSubmissions = (params = {}) =>
  api.get("/submissions", { headers: adminHeaders(), params }).then((r) => r.data);
export const updateSubmissionHandled = (id, handled) =>
  api.patch(`/submissions/${id}`, { handled }, { headers: adminHeaders() }).then((r) => r.data);
